// 'use server'

import { RESET_PASSWORD } from '@/features/auth/services'
import { fetchWithToken } from '@/services'
import { LoginAction } from './login'

export const ResetPwAction = async (values: { email: string; otpToken: string; newPassword: string }) => {
  try {
    const response = await fetchWithToken({
      query: RESET_PASSWORD,
      variables: {
        email: values?.email,
        newPassword: values?.newPassword,
        otpToken: values?.otpToken,
      },
    }).then((res) => res?.payload)
    const token = response?.data?.resetPassword
    if (!token) return { status: 'error', message: response?.errors?.[0]?.message }
    return { status: 'success', data: 'Reset password successfully' }
  } catch (err) {
    return { status: 'error', message: "something's wrong" }
  }
}

/**
 * Action để reset password và tự động đăng nhập
 */
export const LoginAfterResetAction = async (
  email: string,
  otpToken: string,
  newPassword: string,
  callbackUrl?: string | null
) => {
  try {
    // Bước 1: Reset password
    const resetResult = await ResetPwAction({
      email,
      otpToken,
      newPassword,
    })

    if (resetResult?.status === 'error') {
      return {
        status: 'error',
        message: resetResult?.message || 'Không thể đặt lại mật khẩu',
      }
    }

    // Bước 2: Tự động đăng nhập với mật khẩu mới
    const loginResult = await LoginAction({ email, password: newPassword }, callbackUrl)

    if (loginResult?.status === 'error') {
      return {
        status: 'error',
        message:
          'Đặt lại mật khẩu thành công, nhưng không thể đăng nhập tự động. Vui lòng đăng nhập thủ công.',
      }
    }

    return {
      status: 'success',
      message: 'Đặt lại mật khẩu và đăng nhập thành công!',
      data: loginResult?.data,
    }
  } catch (error) {
    console.error('Login after reset error:', error)
    return {
      status: 'error',
      message: 'Có lỗi xảy ra trong quá trình đặt lại mật khẩu',
    }
  }
}
